<template>
  <div>
    <v-container>
      <v-row>
        <v-col md="3">
          <v-card-text>
            <span class="grey--text">時間帯</span>
          </v-card-text>
        </v-col>
        <v-col md="9">
          <v-card-text>
            {{ lesson.schedule.day + "曜日/"　+  lesson.schedule.start + "-" + lesson.schedule.end }}
          </v-card-text>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col md="3">
          <v-card-text>
            <span class="grey--text">報酬額</span>
          </v-card-text>
        </v-col>
        <v-col md="9">
          <v-card-text>
            {{ lesson.wage }}円
          </v-card-text>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col
          v-if="applying"
          md="3">
          <v-card-text>
            <span class="grey--text">応募時コメント</span>
          </v-card-text>
        </v-col>
        <v-col
          v-else
          md="3">
          <v-card-text>
            <span class="grey--text">依頼時コメント</span>
          </v-card-text>
        </v-col>
        <v-col md="9">
          <v-card-text class="line--feed">
            {{ lesson.note }}
          </v-card-text>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-btn
          text
          outlined
          class="ma-3"
          @click="Dialog=true">
          この授業を削除する
        </v-btn>
      </v-row>
      <v-dialog
        v-model="Dialog"
        max-width="400px">
        <v-card>
          <v-container>
            <v-card-text>
              <p>{{ student.fullName() }}さんの授業を削除します。</p>
              <p>依頼者と合意の上、授業の削除を行ってください。</p>
              <p>本当に授業を削除しますか。</p>
            </v-card-text>
          </v-container>
          <v-container>
            <v-row justify="end">
              <v-btn
                outlined
                rounded
                class="ma-3"
                @click="deleteLesson">
                はい
              </v-btn>
              <v-btn
                class="ma-3"
                outlined
                rounded
                @click="Dialog=false">
                いいえ
              </v-btn>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container> 
    <v-divider></v-divider> 
  </div>
</template>

<script>
import { LessonOfferRepository } from '@/repository/LessonOfferRepository.js'
import { firestore } from '@/repository/client/firestore.js'

export default {
  name:'TeacherLessonDetails',
  data() {
    return {
      Dialog: false,
      teacher: this.$store.getters.teacher,
      teacherOfferStudentIds: []
    }
  },
  props: {
    lesson: Object,
    student: Object,
  },
  methods: {
    deleteLesson(lesson) {
      this.Dialog = false
      this.$emit("deleteLesson", this.lesson)
    }
  },
  created: async function() {
    this.offerRepo = new LessonOfferRepository(firestore)
    const offers = await this.offerRepo.listOfAllOffers(this.teacher.uuid)
    this.teacherOfferStudentIds = offers.getStudentIds()
  },
  computed: {
    applying() {
      return this.teacherOfferStudentIds.includes(this.student.id)
    }
  }
}

</script>


